export const CREATE_SURVEY_CAMPAIGN = `
  mutation createSurveyCampaign(
    $input: CreateSurveyCampaignInput!
    $tenant_id: Int!
  ) {
    createSurveyCampaign(input: $input, tenant_id: $tenant_id) {
      __typename
      ... on SurveyCampaign {
        id
        name
        edition
        start_date
        end_date
        status
        display_status
        delivery_method
        recipients
        links_generated
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SCHEDULE_SURVEY_CAMPAIGN = `
  mutation scheduleSurveyCampaign(
    $id: Int!
    $input: ScheduleSurveyCampaignInput!
    $tenant_id: Int!
  ) {
    scheduleSurveyCampaign(id: $id, input: $input, tenant_id: $tenant_id) {
      __typename
      ... on SurveyCampaign {
        id
        start_date
        end_date
        status
        display_status
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SEND_SURVEY_CAMPAIGN_TEST = `
  mutation sendSurveyCampaignTest($id: Int!, $tenant_id: Int!) {
    sendSurveyCampaignTest(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on SurveyCampaign {
        id
        status
        display_status
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const SEND_SURVEY_CAMPAIGN = `
  mutation sendSurveyCampaign($id: Int!, $tenant_id: Int!) {
    sendSurveyCampaign(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on SurveyCampaign {
        id
        status
        display_status
        sent
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const UPDATE_SURVEY_CAMPAIGN = `
  mutation updateSurveyCampaign(
    $id: Int!
    $input: UpdateSurveyCampaignInput!
    $tenant_id: Int!
  ) {
    updateSurveyCampaign(id: $id, input: $input, tenant_id: $tenant_id) {
      __typename
      ... on SurveyCampaign {
        id
        start_date
        end_date
        status
        display_status
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const CANCEL_SURVEY_CAMPAIGN = `
  mutation cancelSurveyCampaign($id: Int!, $tenant_id: Int!) {
    cancelSurveyCampaign(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on SurveyCampaign {
        id
        status
        display_status
        cancelled_at
        cancelled_by_name
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;

export const RESEND_SURVEY_CAMPAIGN = `
  mutation resendSurveyCampaign($id: Int!, $tenant_id: Int!) {
    resendSurveyCampaign(id: $id, tenant_id: $tenant_id) {
      __typename
      ... on SurveyCampaign {
        id
        status
        display_status
        sent
        pending_responses
      }
      ... on ResultError {
        status_code
        message
        message_translation_key
      }
    }
  }
`;
